exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.td-align-right[data-v-0970c1e8] {\n  text-align: right;\n}\n.handle[data-v-0970c1e8] {\n  color: lightgray;\n}\n", ""]);

// exports
